import React, { createContext, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const { instance } = useMsal();
    const [userDetails, setUserDetails] = useState(null);
    const [profileImage, setProfileImage] = useState(null);

    const arrayBufferToBase64 = (buffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    useEffect(() => {
        const fetchUserDetails = async () => {
            const account = instance.getActiveAccount();
            if (!account) {
                // console.error("No active account found!");
                return;
            }

            setUserDetails({
                username: account.username,
                name: account.name,
                userId: account.localAccountId || account.homeAccountId.split(".")[0],
            });

            try {
                const tokenResponse = await instance.acquireTokenSilent({
                    scopes: ["user.read"],
                });

                const response = await axios.get(
                    "https://graph.microsoft.com/v1.0/me/photo/$value",
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.accessToken}`,
                        },
                        responseType: "arraybuffer",
                    }
                );

                const base64Image = `data:${response.headers["content-type"]};base64,${arrayBufferToBase64(
                    response.data
                )}`;
                setProfileImage(base64Image);
            } catch (error) {
                // console.error("Error fetching profile image:", error);
                setProfileImage(null);
            }
        };

        fetchUserDetails();
    }, [instance]);

    const clearUserData = () => {
        setUserDetails(null);
        setProfileImage(null);
    };

    return (
        <UserContext.Provider value={{ userDetails, profileImage, clearUserData }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => React.useContext(UserContext);
